/* eslint-disable no-nested-ternary */
import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Field, Form } from 'formik'
import { useTranslation } from 'react-i18next'
import CheckMarkIcon from 'custom/assets/icons/requests/709510'
import Layout from '../../layout/Layout/Layout'
import Loading from 'custom/assets/loaders/Loading'
import { ServiceRequestSchema } from '../../schemas/others/suggestions'
import FeedbackService from '../../services/feedback.service'
import DashboardService from '../../services/dashboard.service'
import { SIDENAV_KEYS, DIALOG_KEYS } from '../../utils/translation-constants'
import InputError from '../../components/InputError/InputError'
import AccountsService from '../../services/accounts.service'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
// import { resetCarousel } from '../../actions'
import { useDispatch } from 'react-redux'

export default function ServiceRequest() {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [stage, setStage] = useState(0)
    const [message, setMessage] = useState('')
    const [feedbackCategories, setFeedbackCategories] = useState({})
    const [loading, setLoading] = useState(false)
    const [accountList, setAccountList] = useState([])

    const fetchAccounts = useCallback(async () => {
        // dispatch(resetCarousel())
        const x = await AccountsService.getAllAccounts()
        setStage(1)
        setAccountList(x.accountSummaryList)
    })


    useEffect(() => {
        const fetchValues = async () => {
            try {
                setLoading(true)
                const response = await FeedbackService.getFeedbackComplaintCategory()
                setFeedbackCategories(response.values)
                setLoading(false)
            } catch (err) {
                setLoading(false)
            }
        }
        fetchValues()
        fetchAccounts()
    }, [])



    function renderSwitch() {
        switch (stage) {
            case 0:
                return renderLoading()
            case 1:
                return renderForm()
            case 2:
                return <NeoSuccess message={message} linkPath='/dashboard' />
            default:
                return renderLoading()
        }
    }



    const submitServiceRequest = useCallback(
        async (data, { setSubmitting }) => {
            try {
                setSubmitting(true)
                const response = await DashboardService.serviceRequest({
                    category: data.category,
                    suggestion: data.suggestion,
                    referenceNo: data.referenceNo,
                    accountNo: data.accountNo,
                    beneName: data.beneName,
                    amount: data.amount,
                })
                setSubmitting(false)
                setMessage(response.data.message)
                setStage(2)
            } catch (err) {
                setSubmitting(false)
            }
        },
        [feedbackCategories],
    )

    function renderSuccess() {
        return (
            <div className='my-5 py-5 d-flex flex-column text-center'>
                <img src={CheckMarkIcon} alt='Success' />
                <p className='mt-4 text-secondary'>{message}</p>
                <div className='mt-4 mx-auto px-0 col-3'>
                    <button type='button' className='btn btn-neo' onClick={() => setStage(2)}>
                        {t(DIALOG_KEYS.DONE)}
                    </button>
                </div>
            </div>
        )
    }

    function renderLoading() {
        return (
            <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
                <Loading width='50px' height='50px' />
            </div>
        )
    }

    function renderForm() {
        return (
            <Formik
                initialValues={{
                    category: '',
                    suggestion: '',
                    accountNo: '',
                    referenceNo: '',
                    beneName: '',
                    amount: '',
                }}
                validationSchema={ServiceRequestSchema}
                onSubmit={submitServiceRequest}>
                {({ isSubmitting, errors, touched, handleChange,values,setFieldValue }) => (
                    <Form className='mt-5'>
                        <div className='my-4 form-group'>
                            <NeoInput
                                text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.CATEGORY)}
                                mode='select'
                                onChange={handleChange}
                                name='category'
                                list={Object.keys(feedbackCategories)}
                                keyValue={null}
                            />
                            <InputError text={errors.category} touched={touched.category} />
                        </div>

                        <div className="my-4 form-group">
                            <NeoInput
                                text='Account Number'
                                mode='select'
                                onChange={handleChange}
                                name='accountNo'
                                list={accountList}
                                keyValue='accountNo'
                            />
                        </div>
                        <div className='my-4 form-group'>
                            <NeoInput
                                name='referenceNo'
                                onChange={handleChange}
                                text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.REF_NUMBER)}
                            />
                        </div>

                        <div className='my-4 form-group'>
                            <NeoInput
                                name='beneName'
                                onChange={handleChange}
                                text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.BENENAME)}
                            />
                        </div>

                        <div className='my-4 form-group'>
                            <NeoInput
                                text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.AMOUNT)}
                                name='reqamount'
                                mode='amount'
                                onChange={(values) => {
                                    setFieldValue('amount', values.value)
                                  }}
                                  value={values.amount}
                            />
                        </div>

                        <div className='my-4 form-group'>
                            <NeoInput
                                mode='textarea'
                                text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.SUGGESTION)}
                                name='suggestion'
                                onChange={handleChange}
                                rows='7'
                            />
                            <InputError text={errors.suggestion} touched={touched.suggestion} />
                        </div>

                        <div className='mt-4 ml-auto px-0 col-5'>
                            {isSubmitting ? (
                                renderLoading()
                            ) : (
                                    <NeoButton type='submit' disabled={isSubmitting} text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.SUBMIT)} />
                                )}
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }

    return (
            <Layout>
                <div >
                    <h4 className='font-weight-bold'>{t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.TITLE)}</h4>
                    <p className='lead'>{t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.SUBTITLE)}</p>
                    {renderSwitch()}
                </div>
            </Layout>
    )
}
